import * as sterlingparker from './MatchesModal.styles.sterlingparker';
import * as betprofessor from './MatchesModal.styles.betprofessor';
import * as volcanobet from './MatchesModal.styles.volcanobet';
import * as junglebet from './MatchesModal.styles.junglebet';
import * as puntgenie from './MatchesModal.styles.puntgenie';
import * as fiestabet from './MatchesModal.styles.fiestabet';
import * as puntcity from './MatchesModal.styles.puntcity';
import * as betgalaxy from './MatchesModal.styles.betgalaxy';
import * as betroyale from './MatchesModal.styles.betroyale';
import * as juicybet from './MatchesModal.styles.juicybet';
import * as goldenrush from './MatchesModal.styles.goldenrush';
import * as vikingbet from './MatchesModal.styles.vikingbet';
import * as questbet from './MatchesModal.styles.questbet';
import * as wellbet from './MatchesModal.styles.wellbet';
import * as sugarcastle from './MatchesModal.styles.sugarcastle';
import * as oldgill from './MatchesModal.styles.oldgill';
import * as buffalobet from './MatchesModal.styles.buffalobet';
import * as titanbet from './MatchesModal.styles.titanbet';
import * as gigabet from './MatchesModal.styles.gigabet';
import * as slambet from './MatchesModal.styles.slambet';
import * as betstride from './MatchesModal.styles.betstride';
import * as templebet from './MatchesModal.styles.templebet';
import * as goldenbet888 from './MatchesModal.styles.goldenbet888';
import * as hyperbet from './MatchesModal.styles.hyperbet';
import * as bet777 from './MatchesModal.styles.bet777';
import * as chromabet from './MatchesModal.styles.chromabet';
import * as bet575 from './MatchesModal.styles.bet575';
import * as betblast from './MatchesModal.styles.betblast';
import * as pyramidbet from './MatchesModal.styles.pyramidbet';
import * as magnumbet from './MatchesModal.styles.magnumbet';

import { EThemesOG } from '@/constants/themeConfig';

export const styleImports: Partial<Record<EThemesOG, any>> = {
  sterlingparker,
  betprofessor,
  volcanobet,
  junglebet,
  puntgenie,
  fiestabet,
  puntcity,
  betgalaxy,
  betroyale,
  juicybet,
  goldenrush,
  vikingbet,
  questbet,
  wellbet,
  sugarcastle,
  oldgill,
  buffalobet,
  titanbet,
  gigabet,
  slambet,
  betstride,
  templebet,
  goldenbet888,
  hyperbet,
  bet777,
  chromabet,
  bet575,
  betblast,
  pyramidbet,
  magnumbet,
};
